import React, { useRef, useState, useEffect } from 'react'
import useFetch from 'use-http'
import { navigate, RouteComponentProps } from '@reach/router'

import { Alert, Loading, Stack, Text } from '@myxplor/stardust'

import { Container, Header, Footer, Content } from '~/layouts/ScrollableContentLayout'

type Props = RouteComponentProps

const UpdateXplorIdsForm = (_props: Props) => {
  const [alertMessage, setAlertMessage] = useState<Nullable<string>>(null)
  const updateXplorIdToken = new URLSearchParams(window.location.search).get('token')
  const { request, loading, response } = useFetch()
  const hasSubmitted = useRef(false)

  useEffect(() => {
    if (!updateXplorIdToken) {
      navigate('/update-xid/expired')
      return
    }

    // Remove the token from the address bar/history as soon as we have it.
    history.replaceState(null, '', window.location.pathname)

    if (hasSubmitted.current) return
    hasSubmitted.current = true
    postConfirm()
  }, [])

  async function postConfirm() {
    const body = await request.post('/api/v1/xplor-id/confirm', { token: updateXplorIdToken })

    if (response.status === 200 && body?.success === true) {
      navigate('/update-xid/all-done')
    } else if (response.status === 200 && body?.success === false && body?.resend === true) {
      navigate('/update-xid/expired', {
        state: {
          message:
            'Your confirmation email has expired. A new confirmation email has been sent to your inbox.',
        },
      })
    } else if (response.status === 400) {
      navigate('/update-xid/expired', { state: { message: 'Something went wrong. Please contact support.' } })
    } else {
      setAlertMessage('Something has gone wrong. Please contact support.')
    }
  }

  const onClose = () => {
    history.replaceState(null, '', '/')
    navigate('/')
  }

  if (loading) {
    return (
      <Container>
        <Content>
          <Stack align="center" space="small">
            <Loading size="large" />
          </Stack>
        </Content>
      </Container>
    )
  }

  return (
    <Container>
      <Header icon="close" onBack={onClose}>
        Account Update
      </Header>
      <Content>
        <Stack align="center" space="small">
          {alertMessage && <Alert tone="negative">{alertMessage}</Alert>}
          <Text color="higherEmphasis" prefab="body">
            Confirming your account update...
          </Text>
        </Stack>
      </Content>
      <Footer />
    </Container>
  )
}

export default UpdateXplorIdsForm
